import React from 'react'
import { connect } from 'react-redux'
import accounting from 'accounting'
import includes from 'lodash/includes'
import toLower from 'lodash/toLower'

import Modal from 'react-responsive-modal'
import FormChangeImage from '../../Containers/Attraction/FormChangeImage'
import FormChangeBanner from '../../Containers/Attraction/FormChangeBanner'

import AttractionActions from '../../Redux/AttractionRedux'
import FilesActions from '../../Redux/FilesRedux'

class AttractionDetail extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      tab: null,
      edit: false,
      form: {
        language_code: toLower(props.setting.language_code),
        currency_code: '',
        highlights: '',
        additional_info: '',
        description: ''
      },
      files: {},
      showModal: null,
      selected: {
        item: {},
        dimension: null,
        banner: null
      }
    }
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      form: {
        ...this.state.form,
        language_code: toLower(nextProps.setting.language_code),
        currency_code: nextProps.setting.currency_code,
        highlights: nextProps.attraction.detail.highlights,
        additional_info: nextProps.attraction.detail.additional_info,
        description: nextProps.attraction.detail.description
      }
    })
  }

  componentDidMount = () => {
    let filter = {
      language_code: this.props.setting.language_code,
      currency_code: this.props.setting.currency_code
    }
    let data = {
      id: this.props.detailId,
      filter
    }
    this.props.getAttractionDetail(data)
    this.props.reset()
  }

  _toggleModal = (modalId = null, item, dimension) => {
    this.setState({
      showModal: modalId,
      selected: {
        ...this.state.selected,
        item,
        dimension
      }
    })

    if (!modalId) {
      this.props.clearCache()
      this.props.getAttractionDetail({ id: this.props.detailId })
    }
  }

  _toggleTab = (tabName = null) => {
    this.setState({
      tab: tabName
    })
  }

  _toggleEdit = () => {
    this.setState({
      edit: !this.state.edit
    })
  }

  _inputChange = (event, field) => {
    const val = event.target.value
    let newState = { ...this.state }
    newState['form'][field] = val
    this.setState({ newState })
  }

  _fileSelect = (event, item, dimension) => {
    let reader = new FileReader()
    let file = event.target.files[0]
    let newImage = { ...this.state.files }

    reader.onloadend = () => {
      newImage[item.uuid + dimension] = reader.result
      this.setState({
        files: newImage
      })
    }

    reader.readAsDataURL(file)
  }

  _submit = () => {
    const form = this.state.form
    const data = {
      id: this.props.attraction.detail.id,
      form
    }
    this.props.updateAttractionDetail(data)
    this.props.closeModal()
  }

  _toggleChangeBanner = (modalId = null, bannerType = 'wide') => {
    this.setState({
      showModal: modalId,
      selected: {
        ...this.state.selected,
        banner: bannerType
      }
    })
  }

  render () {
    const { detail, fetching, err, processing } = this.props.attraction
    // const { files } = this.state

    const ImageTab = () => {
      return (
        <div>
          {detail.local_photos && detail.local_photos.map((item, i) => {
            return (
              <div key={i} className='mb-3' style={{ borderBottom: '1px solid #ddd' }}>
                <div className='table-responsive'>
                  <table className='table table-hover table-bordered'>
                    <thead>
                      <tr>
                        <th>Caption</th>
                        <th>Dimension</th>
                        <th>Image</th>
                        {this.state.edit && <th>Edit Image</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(item.paths).map((dimension, key) => (
                        <tr key={key}>
                          {key === 0 &&
                            <td rowSpan={Object.keys(item.paths).length}>{item.caption || '-'}</td>
                          }
                          <td>
                            {dimension}
                          </td>
                          <td>
                            <img src={item.paths[dimension]} alt='' height='175px' className='img img-responsive' />
                          </td>
                          {this.state.edit &&
                            <td>
                              <button className='btn btn-primary' onClick={() => this._toggleModal('change-image', item, dimension)}>Change Image</button>
                            </td>
                          }
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )
          })}
          <Modal open={this.state.showModal === 'change-image'} onClose={this._toggleModal} closeOnOverlayClick>
            <FormChangeImage attractionId={this.props.detailId} item={this.state.selected.item} dimension={this.state.selected.dimension} closeModal={() => this._toggleModal()} />
          </Modal>
        </div>
      )
    }

    const BannerTab = () => {
      return (
        <div className='row'>
          <div className='form-group col-6 text-center'>
            <label className='control-label'>Web</label>
            <div>
              {(detail.banner_url && detail.banner_url.wide)
                ? <img src={detail.banner_url.wide} alt='' className='img img-responsive mb-2' style={{ width: '100%' }} />
                : <strong>- NO IMAGE -</strong>
              }
            </div>
            {this.state.edit &&
              <button className='btn btn-primary' onClick={() => this._toggleChangeBanner('change-banner', 'wide')}>Change Banner</button>
            }
          </div>

          <div className='form-group col-6 text-center'>
            <label className='control-label'>Mobile</label>
            <div>
              {(detail.banner_url && detail.banner_url.wide_mobile)
                ? <img src={detail.banner_url.wide_mobile} alt='' className='img img-responsive mb-2' style={{ width: '100%' }} />
                : <strong>- NO IMAGE -</strong>
              }
            </div>
            {this.state.edit &&
              <button className='btn btn-primary' onClick={() => this._toggleChangeBanner('change-banner', 'wide_mobile')}>Change Banner</button>
            }
          </div>

          <Modal open={this.state.showModal === 'change-banner'} onClose={this._toggleModal} closeOnOverlayClick>
            <FormChangeBanner attractionId={this.props.detailId} banners={detail.banner_file} bannerType={this.state.selected.banner} closeModal={() => this._toggleModal()} />
          </Modal>
        </div>
      )
    }

    return (
      <div className='section' style={{ width: '75vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>
            Attraction Detail
            {(fetching || processing) && <div className='badge badge-info ml-2'>{fetching ? 'Loading' : 'Processing'} ...</div>}
          </h4>
        </div>
        {err && <div className='alert alert-danger'>{err}</div>}

        {detail &&
          <div className='section'>
            <div className='mb-4'>
              <h4 className='title'>{ detail.title || '-' }</h4>
              <p className='title-description'>
                {/* <span className="badge badge-secondary">ID</span>{" "}
                { detail.short_id } */}
              </p>
            </div>
            <div>
              <section>
                <header className='title'>
                  <h3>Images</h3>
                </header>
                <ImageTab />
              </section>
              <section>
                <header className='title'>
                  <h3>Banner</h3>
                </header>
                <BannerTab />
              </section>
              <section>
                <div className='form-group row'>
                  <div className='col-xs-12 col-sm-2'>
                    <label className='control-label'>Description</label>
                  </div>
                  <div className='col-xs-12 col-sm-10'>
                    {detail.description || '-'}
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-xs-12 col-sm-2'>
                    <label className='control-label'>Base Price</label>
                  </div>
                  <div className='col-xs-12 col-sm-10'>
                    <em>
                      {
                        detail.provider === 'BMG'
                          ? accounting.formatMoney(detail.normal_price, { symbol: this.props.setting.currency_code, format: '%s %v' })
                          : accounting.formatMoney(detail.final_price, { symbol: this.props.setting.currency_code, format: '%s %v' })
                      }
                    </em>
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-xs-12 col-sm-2'>
                    <label className='control-label'>City</label>
                  </div>
                  <div className='col-xs-12 col-sm-10'>
                    {detail.city && detail.city.name}
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-xs-12 col-sm-2'>
                    <label className='control-label'>Geolocation</label>
                  </div>
                  <div className='col-xs-12 col-sm-10'>
                    Lat: <em>{detail.latitude}</em> <br /> Lon: <em>{detail.longitude}</em>
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-xs-12 col-sm-2'>
                    <label className='control-label'>Business Hours</label>
                  </div>
                  <div className='col-xs-12 col-sm-10'>
                    {detail.business_hours_from} - {detail.business_hours_to}
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-xs-12 col-sm-2'>
                    <label className='control-label'>Highlights</label>
                  </div>
                  <div className='col-xs-12 col-sm-10'>
                    {detail.highlights}
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-xs-12 col-sm-2'>
                    <label className='control-label'>Additional Info</label>
                  </div>
                  <div className='col-xs-12 col-sm-10'>
                    {detail.additional_info}
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-xs-12 col-sm-2'>
                    <label className='control-label'>Packages</label>
                  </div>
                  <div className='col-xs-12 col-sm-10 table-responsive'>
                    <table className='table table-hover table-striped'>
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>Title</th>
                          <th>Prices</th>
                          <th>Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          detail.attraction_packages && detail.attraction_packages.map((item, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{item.title}</td>
                              {
                                item.provider === 'BMG'
                                  ? <td width='30%'>
                                    <ul className='list-unstyled'>
                                      {
                                        Object.keys(item.prices).map((key, index) => {
                                          if (includes(key, 'normal') || !item.prices[key]) { return null }
                                          return (
                                            <li key={index}>
                                              (<strong>{key}</strong>) {accounting.formatMoney(item.prices[key], { symbol: this.props.setting.currency_code, format: '%s %v' })}
                                            </li>
                                          )
                                        })
                                      }
                                    </ul>
                                  </td>
                                  : <td width='30%'>
                                    <ul className='list-unstyled'>
                                      {
                                        item.prices.map((key, index) => (
                                          <li key={index}>
                                            (<strong>{key.name}</strong>) {accounting.formatMoney(key.price, { symbol: this.props.setting.currency_code, format: '%s %v' })}
                                          </li>
                                        ))
                                      }
                                    </ul>
                                  </td>
                              }
                              <td width='40%'>{item.description}</td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-xs-12 col-sm-2'>
                    <label className='control-label'>Instant Confirmation</label>
                  </div>
                  <div className='col-xs-12 col-sm-10'>
                    <p className={`badge badge-pill badge-${detail.is_instant ? 'success' : 'danger'}`}>{detail.is_instant ? 'Yes' : 'No'}</p>
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-xs-12 col-sm-2'>
                    <label className='control-label'>Meta-title</label>
                  </div>
                  <div className='col-xs-12 col-sm-10'>
                    {detail.meta_title || ''}
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-xs-12 col-sm-2'>
                    <label className='control-label'>Meta-description</label>
                  </div>
                  <div className='col-xs-12 col-sm-10'>
                    {detail.meta_description || ''}
                  </div>
                </div>
              </section>
            </div>
          </div>
        }
        <div className='form-group d-flex justify-content-end'>
          <button className='btn btn-lg btn-secondary' onClick={() => this.props.closeModal()}>Close</button>
        </div>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  attraction: state.attraction,
  files: state.files
})

const dispatchToProps = (dispatch) => ({
  getAttractionDetail: (data) => dispatch(AttractionActions.attractionDetailRequest(data)),
  updateAttractionDetail: (data) => dispatch(AttractionActions.attractionUpdateRequest(data)),
  clearCache: () => dispatch(AttractionActions.attractionClearCacheRequest()),
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
  reset: () => dispatch(FilesActions.filesUploadReset())
})

export default connect(stateToProps, dispatchToProps)(AttractionDetail)



// WEBPACK FOOTER //
// ./src/Containers/Attraction/AttractionDetail.js